import { apiClient } from '@borradh-workspace/api-client';
import {
  type ReportsAvailabilityResponse,
  reportsAvailabilitySchema,
} from '@borradh-workspace/contracts';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/query-keys';

/**
 * Whether the active clinic has the Reports page (`rollout-reports`). The API
 * answers rather than PostHog in the browser, so the sidebar, the page and the
 * report endpoints always agree.
 */
export const getReportsAvailabilityQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.reports.availability(),
    queryFn: () =>
      apiClient.get<ReportsAvailabilityResponse>('reports/availability', {
        schema: reportsAvailabilitySchema,
      }),
    staleTime: 5 * 60 * 1000,
  });

export const useReportsAvailability = () => {
  const query = useQuery(getReportsAvailabilityQueryOptions());
  return {
    reportsEnabled: query.data?.enabled === true,
    isPending: query.isPending,
  };
};
